import React from 'react';
import Information from './Information';
const InformationS = ({ color, ...props }) => (React.createElement(Information, Object.assign({ color: color, size: 24 }, props)));
InformationS.displayName = 'InformationS'; // Fix for tsc
export default InformationS;
//# sourceMappingURL=InformationS.js.map